import { Box } from "@mui/material";
import { SnackbarHeader } from "components/primitives/snackbar/SnackbarHeader";
import { SnackbarSubHeader } from "components/primitives/snackbar/SnackbarSubtitle";
import { type ForwardedRef, forwardRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { Maybe, User } from "types";
import { getSnackbarData, type SnackbarType } from "./snackbarTypes";

type Props = {
	user?: Maybe<User>;
	variant: SnackbarType;
	subheader?: string;
};

const SnackbarContentComp = ({ user, variant, subheader: subheaderOverride }: Props, ref: ForwardedRef<unknown>) => {
	const { t } = useTranslation();

	const {
		header,
		subheader: subheaderDefault,
		image,
	} = useMemo(() => getSnackbarData(t, variant, user?.name ?? ""), [t, variant, user]);

	const subheader = subheaderOverride ? subheaderOverride : subheaderDefault;

	return (
		<Box display="flex" justifyContent="space-between" ref={ref} sx={{ width: "100%" }}>
			<Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center">
				<SnackbarHeader>{header}</SnackbarHeader>
				{subheader && <SnackbarSubHeader>{subheader}</SnackbarSubHeader>}
			</Box>
			<img src={image.src} alt={image.alt} width={132} height={132} />
		</Box>
	);
};

// biome-ignore lint/suspicious/noReactForwardRef: forwardRef needed for MUI Snackbar integration
export const SnackbarContent = forwardRef(SnackbarContentComp);
